<template>
  <div>
    <div class="side-frame-success" style="display: inline-block;">
      <span style="font-size: 14px; color: #606266">
        {{ $l('table_label_order_goods_packaging_cost') || '包装测算' }}
      </span>
    </div>
    <div v-if="!disabled" style="display: inline-block;">
      <el-divider direction="vertical"></el-divider>
      <b-button
        class="mr-2 ml-2"
        size="sm"
        variant="outline-success"
        @click="$emit('openEditDialog', { optType: 'add' })"
        ><i class="el-icon-plus" />{{ $l('INDEX.btn_add') || '新增' }}
      </b-button>
      <b-button
        class="mr-2"
        size="sm"
        variant="outline-danger"
        @click="$emit('batchDel')"
        ><i class="el-icon-delete" />{{ $l('INDEX.btn_delete') || '删除' }}
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  props: { disabled: { type: Boolean, default: false } },
}
</script>
